import gql from 'graphql-tag';

export const REFRESH_CLIENT_SOCIAL_ANALYTICS = gql`
  mutation RefreshClientSocialAnalyticsMutation {
    refreshClientSocialAnalytics {
      requestId
    }
  }
`;
